import { InferFormValues, JsonFormSchemaV2 } from '@/unity-apps/components/component-library/FormComponent/types'
import { ComposedSheet } from './ComposedSheet'
import { ReactNode } from 'react'
import { TooltipWrapper } from './TooltipWrapper'
import { FormContentV2 } from '@/unity-apps/components/component-library/FormComponent/FormContentV2'

export function SheetWithForm({
  schema,
  onSubmit,
  trigger,
  triggerTooltip,
}: {
  schema: JsonFormSchemaV2
  onSubmit: (data: InferFormValues<typeof schema>) => void
  trigger: ReactNode
  triggerTooltip?: string
}) {
  const { title, description, ...rest } = schema

  const sheet = (
    <ComposedSheet title={title} description={description} trigger={triggerTooltip ? undefined : trigger}>
      <FormContentV2 schema={rest} submitHandler={onSubmit} />
    </ComposedSheet>
  )

  if (triggerTooltip)
    return (
      <TooltipWrapper tooltip={triggerTooltip} wrapTrigger triggerComponent={sheet}>
        {trigger}
      </TooltipWrapper>
    )

  return sheet
}
